import { useText } from 'hooks';
import { Container } from './styled';

// Display.MissingDepot
export const MissingDepot = () => {
  const getText = useText();
  return <Container>{getText('missing_depot')}</Container>;
};
